export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
};

export const isChromium = () => {
    return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
};
